import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latest = articles.slice(0, 4);

  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8" aria-label="最新爆料">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-primary-500">最新爆料</h2>
          <Link
            to="/category/wanghong-baoliao"
            className="text-sm text-accent-600 hover:text-accent-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 md:gap-5 rounded-xl bg-background-100 p-4 md:p-5 hover:bg-background-200/70 transition-colors"
            >
              <div className="shrink-0 w-28 h-20 md:w-36 md:h-24 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col min-w-0">
                <h3 className="font-heading text-sm md:text-base text-foreground-800 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <div className="mt-auto pt-2 flex items-center gap-2 text-xs text-foreground-400">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.views.toLocaleString()}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}